import { queryOptions } from '@tanstack/react-query'

import type { SimpleChannels } from '@/api/generated-api-and-types'
import { SingleChannel, Topic } from '@/api/generated-api-and-types'

import { createApiMethod, type } from './utils/createApiMethod'

export const channels = {
  all: createApiMethod({
    method: 'GET',
    path: '/channels',
    response: type<{ channels: SingleChannel[] }>(),
  }),
  best: createApiMethod({
    method: 'GET',
    path: '/channels/best_topics',
    response: type<SingleChannel>(),
  }),
  category: createApiMethod({
    method: 'GET',
    path: '/channels/category/:slug',
    response: type<SingleChannel>(),
  }),
  highlighted: createApiMethod({
    method: 'GET',
    path: '/channels/highlighted_topic',
    response: type<Topic>(),
  }),
  internal: createApiMethod({
    method: 'GET',
    path: '/channels/internal',
    response: type<SingleChannel>(),
  }),
  list: createApiMethod({
    method: 'GET',
    path: '/channels/names',
    response: type<SimpleChannels>(),
  }),
  new: createApiMethod({
    method: 'GET',
    path: '/channels/new_topics',
    response: type<SingleChannel>(),
  }),
  personal: createApiMethod({
    method: 'GET',
    path: '/channels/personal',
    response: type<SingleChannel>(),
  }),
}

export const channelsQueries = {
  all: () =>
    queryOptions({
      queryKey: ['channels'] as const,
      queryFn: () => channels.all(),
    }),
  best: () =>
    queryOptions({
      queryKey: [...channelsQueries.all().queryKey, 'best'],
      queryFn: () => channels.best(),
    }),
  categorized: (slug: string) =>
    queryOptions({
      queryKey: [...channelsQueries.all().queryKey, slug] as const,
      queryFn: () => channels.category({ params: { slug } }),
    }),
  highlighted: () =>
    queryOptions({
      queryKey: [...channelsQueries.all().queryKey, 'highlighted'],
      queryFn: () => channels.highlighted(),
    }),
  internal: () =>
    queryOptions({
      queryKey: [...channelsQueries.all().queryKey, 'internal'],
      queryFn: () => channels.internal(),
    }),
  list: () =>
    queryOptions({
      queryKey: [...channelsQueries.all().queryKey, 'list'],
      queryFn: () => channels.list(),
    }),
  new: () =>
    queryOptions({
      queryKey: [...channelsQueries.all().queryKey, 'new'],
      queryFn: () => channels.new(),
    }),
  personal: () =>
    queryOptions({
      queryKey: [...channelsQueries.all().queryKey, 'personal'],
      queryFn: () => channels.personal(),
    }),
}
